import { render } from "./Recordpage.vue?vue&type=template&id=83ec2746&scoped=true&ts=true"
import script from "./Recordpage.vue?vue&type=script&lang=ts"
export * from "./Recordpage.vue?vue&type=script&lang=ts"

import "./Recordpage.vue?vue&type=style&index=0&id=83ec2746&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/democratielab-speech/democratielab-speech/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-83ec2746"]])

export default __exports__